import bindEvent from '../../scripts/util/bindEvent';
import qsa from '../../scripts/util/DOM/qsa';
import qs from '../../scripts/util/DOM/qs';
import addClass from '../../scripts/util/DOM/addClass';
import isElement from '../../scripts/util/isElement';
import $ from 'jquery';

const selectors = {
	swither: '.content-switcher__item',
	content: '.content-switcher__content',
	default: 'about-sites'
};

const classes = {
	hide: 'hide',
	show: 'show',
	activeButton: 'content-switcher__item_active'
};

const removeCls = cls => elem => {
	elem.classList.remove(cls);
};

const removeEachCls = (elems, cls) => {
	for (let i = 0, max = elems.length; i < max; i++) {
		removeCls(cls)(elems[i]);
	}
};

const setActiveButton = id => {
	const link = qsa('a' + id)[0];
	const links = qsa(selectors.swither);

	removeEachCls(links, classes.activeButton);
	addClass(classes.activeButton)(link);
};

const hideContent = () => {
	const content = qsa(selectors.content);

	$('.mac-slider .tooltip').css('opacity', 0);
	removeEachCls(content, classes.show);
};

const showContent = e => {
	let id = (window.location.pathname.indexOf('about-sites') !== -1) ? 'about-sites' : 'about-shops';
	if (typeof e !== 'undefined') {
		id = ($(e.target).hasClass('about-shops')) ? 'about-shops' : selectors.default;
	}
	const content = qs('#' + id);
	if (isElement('#' + id)) {
		setActiveButton('.' + id);
		hideContent();
		addClass(classes.show)(content);
	}

};

const reInitSlider = () => {
	setTimeout(() => {
		$('#mac-slider').slick('reinit');
	}, 300);
};

const showContentWithTimeout = e => {
	e.preventDefault();
	setTimeout(() => showContent(e), 100);
	reInitSlider();
};

const render = () => {
	showContent();
	bindEvent(selectors.swither, 'click', showContentWithTimeout);
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/content-switcher/content-switcher.js